export const blogTagsData = [
    {
      key: "1",
      TAGS: "Road Trip Essentials",
      CREATEDDATE: "24 Jan 2025",
      STATUS: "Published",
    },
    {
      key: "2",
      TAGS: "Best SUVs",
      CREATEDDATE: "19 Dec 2024",
      STATUS: "Unpublish",
    },
    {
      key: "3",
      TAGS: "Affordable Rides",
      CREATEDDATE: "11 Dec 2024",
      STATUS: "Published",
    },
    {
      key: "4",
      TAGS: "Exotic Cars",
      CREATEDDATE: "29 Nov 2024",
      STATUS: "Published",
    },
    {
      key: "5",
      TAGS: "Insurance Coverage",
      CREATEDDATE: "03 Nov 2024",
      STATUS: "Published",
    },
    {
      key: "6",
      TAGS: "Electric Cars",
      CREATEDDATE: "31 Oct 2024",
      STATUS: "Published",
    },
    {
      key: "7",
      TAGS: "Holiday Offers",
      CREATEDDATE: "15 Oct 2024",
      STATUS: "Unpublish",
    },
    {
      key: "8",
      TAGS: "Cross-Country Trips",
      CREATEDDATE: "26 Sep 2024",
      STATUS: "Unpublish",
    },
    {
      key: "9",
      TAGS: "Cross-Country Trips",
      CREATEDDATE: "01 Sep 2024",
      STATUS: "Published",
    },
    {
      key: "10",
      TAGS: "Rental Car Care",
      CREATEDDATE: "15 Aug 2024",
      STATUS: "Published",
    },
    {
      key: "11",
      TAGS: "Must-Visit Cities",
      CREATEDDATE: "15 Aug 2024",
      STATUS: "Published",
    },
];